<template>
  <div class="public-header" id="public-header-id">
    <div class="header-banner">
      <div class="banner-box">
        <div class="banner-logo">
          <img src="../assets/image/header-logo.png" alt="国家广电人才网" />
        </div>
        <div class="banner-search">
          <img
            class="search-icon"
            src="../assets/image/hearder-search-icon.png"
            alt="搜索"
          />
          <input
            class="search-input"
            type="text"
            v-model="searchValue"
            placeholder="请输入内容"
            @keyup.enter="handleSearch"
          />
          <button class="search-but" @click="handleSearch">搜索</button>
        </div>
      </div>
    </div>

    <div class="header-nav">
      <ul class="nav-main">
        <li
          class="main-items"
          v-for="item in navList"
          :key="item.label"
          @click="routerPush(item)"
        >
          <img class="item-imgs" :src="item.iconPath" :alt="item.label" />
          <span>{{ item.label }}</span>
          <ul>
            <li
              v-for="sub in item.children || []"
              :key="item.label + sub.label"
              @click="routerPush(sub)"
            >
              {{ sub.label }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { EventBus } from '@/libs/eventBus'
export default {
  name: 'PublicHeader',
  data() {
    return {
      searchValue: '',
      navList: [
        {
          label: '首页',
          iconPath: require('../assets/image/nav-logo1.png'),
          routerPath: '/',
          routerQuery: {},
          children: []
        },
        {
          label: '人才培养',
          iconPath: require('../assets/image/nav-logo2.png'),
          routerPath: '',
          routerQuery: {},
          children: [
            {
              label: '面授培训',
              routerPath: '/faceList',
              routerQuery: {}
            },
            {
              label: '内训',
              routerPath: '/trainDetail',
              routerQuery: {}
            },
            {
              label: '岗位培训',
              routerPath: '/careerMatrix/7',
              routerQuery: { }
            }
          ]
        },
        {
          label: '人才服务',
          iconPath: require('../assets/image/nav-logo3.png'),
          routerPath: '',
          routerQuery: {},
          children: [
            {
              label: '劳务派遣',
              routerPath: '/talentService',
              routerQuery: {
                id: '1'
              }
            },
            {
              label: '档案管理',
              routerPath: '/talentService',
              routerQuery: {
                id: '2'
              }
            },
            {
              label: '人事代理',
              routerPath: '/talentService',
              routerQuery: {
                id: '3'
              }
            }
          ]
        },
        {
          label: '证书查询',
          iconPath: require('../assets/image/nav-logo4.png'),
          routerPath: '/certificate',
          routerQuery: {}
        },
        {
          label: '关于我们',
          iconPath: require('../assets/image/nav-logo5.png'),
          routerPath: '',
          routerQuery: {},
          children: [
            {
              label: '广电总局人才中心',
              routerPath: '/aboutUs',
              routerQuery: {
                id: '2'
              }
            },
            {
              label: '新广汇贤公司介绍',
              routerPath: '/aboutUs',
              routerQuery: {
                id: '1'
              }
            },
            {
              label: '人才培养计划',
              routerPath: '/aboutUs',
              routerQuery: {
                id: '3'
              }
            }
          ]
        }
      ]
    }
  },
  watch: {
    $route() {
      this.searchValue = this.$route.query.searchValue || ''
    }
  },
  methods: {
    routerPush(row) {
      const { routerPath = '', routerQuery = {} } = row ?? {}
      if (!routerPath) return
      this.$router.push({
        path: routerPath,
        query: routerQuery ?? {}
      })
    },
    handleSearch() {
      const { searchValue } = this
      if (!searchValue) {
        this.$message.error('请输入搜索内容')
        return
      }
      this.$router.push({
        path: '/search',
        query: { searchValue } // 暂时
      })
      EventBus.$emit('searchValue', searchValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.public-header {
  .header-banner {
    background-image: url(../assets/image/header-bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 0 0;
    padding: 53px 0 43px 0;
    .banner-box {
      width: 1200px;
      margin: 0 auto;
      overflow: hidden;
      .banner-logo {
        width: 396px;
        height: 100px;
        float: left;

        > img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .banner-search {
        width: 325px;
        height: 40px;
        border: 2px solid #ffffff;
        border-radius: 24px;
        float: right;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 16px;
        // background: url(../assets/images/inputbg.png) no-repeat;
        background-color: #197DFF;

        .search-icon {
          display: block;
          width: 20px;
          height: 20px;
          margin: 0 12px 0 13px;
        }

        .search-input {
          outline: none;
          background: none;
          border: none;
          color: #ffffff;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
          flex: 1;
          font-family: Microsoft YaHei;

          &::-webkit-input-placeholder {
            color: #fff;
            font-size: 14px;
          }

          &:-moz-placeholder {
            color: #fff;
            font-size: 14px;
          }

          &::-moz-placeholder {
            color: #fff;
            font-size: 14px;
          }

          &:-ms-input-placeholder {
            color: #fff;
            font-size: 14px;
          }
        }

        .search-but {
          outline: none;
          border: none;
          width: 91px;
          height: 44px;
          background: #d00d0d;
          border-radius: 20px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 8px;
          margin-right: -2px;
          cursor: pointer;
        }
      }
    }
  }

  .header-nav {
    height: 50px;
    background: linear-gradient(0deg, #004bad 0%, #2070d4 100%);

    .nav-main {
      width: 1200px;
      height: 100%;
      margin: 0 auto;

      .main-items {
        float: left;
        box-sizing: border-box;
        width: 20%;
        height: 100%;
        cursor: pointer;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;

        &:not(&:last-child) {
          border-right: 2px solid rgb(91, 181, 246);
        }

        > img {
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }

        > span {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }

        > ul {
          display: none;
          width: 100%;
          position: absolute;
          left: 0;
          top: 50px;
          z-index: 10001;

          > li {
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            background: #ffffff;
            border: 1px solid #d5d5d5;
            &:hover {
              background: #4b99ff;
              font-size: 20px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
            }
          }
        }

        &:hover {
          background: #d00d0d;
          > ul {
            display: block;
          }
        }
      }
    }
  }
}
</style>
